import React, { useState } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { RxDotFilled } from "react-icons/rx"


const ImageSlider = () => {
  const slides = [
    {
      url: "https://images.unsplash.com/photo-1464093515883-ec948246accb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2659&q=80",
      title: "Lobster",
    },
    {
      url: "https://images.unsplash.com/photo-1512132411229-c30391241dd8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80",
      title: "Sushi",
    },
    {
      url: "https://images.unsplash.com/photo-1473093295043-cdd812d0e601?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80",
      title: "Pasta",
    },
    {
      url: "https://images.unsplash.com/photo-1539136788836-5699e78bfc75?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80",
      title: "Salmon",
    },
  ];

 const [currentIndex, setCurrentIndex] = useState(0);

 const prevSlide = () => {
  const isFirstSlide = currentIndex ===0;
  const newIndex = isFirstSlide ? slides.length-1 : currentIndex-1;
  setCurrentIndex(newIndex);
 };

 const nextSlide = () => {
  const isLastSlide = currentIndex === slides.length-1;
  const newIndex = isLastSlide ? 0 : currentIndex + 1;
  setCurrentIndex(newIndex) 
 };

const goToSlide = (slideIndex) => {
  setCurrentIndex(slideIndex)
}

  return (
    <div className="max-w-[1400px] h-[500px] w-full m-auto py-16 px-4 relative group">
      <div
        className="w-full h-full rounded-2xl bg-center bg-cover duration-500 "
        style={{ backgroundImage: `url(${slides[currentIndex].url})` }}
      ></div>

      {/* left Arrow */}
      <div className="absolute top-[50%] -tranlate-x-0 tranlate-y-[-50] left-5 text-2xl rounded-full p-2 group-hover:bg-black/30 text-white cursor-pointer ">
        <BsChevronCompactLeft onClick={prevSlide} className="text-transparent group-hover:text-white" size={30} />
      </div>
      {/* Right Arrow */}
      <div className="absolute top-[50%] -tranlate-x-0 tranlate-y-[-50] right-5 text-2xl rounded-full p-2 group-hover:bg-black/30 text-white cursor-pointer">
        <BsChevronCompactRight onClick={nextSlide} className="text-transparent group-hover:text-white" size={30} />
      </div>

      <div className="flex top-4 justify-center py-2">
        {slides.map((slide, slideIndex) => (
          <div className="text-2xl cursor-pointer" key={slideIndex} onClick={() => goToSlide(slideIndex)}>
            <RxDotFilled />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
